<template>
  <div class="mb-8">
    <div v-if="$vuetify.breakpoint.mdAndUp">
 
      <v-row no-gutters class="products-wrap">
        <v-col
          class="overflow-hidden position-relative pa-0"
          v-for="(product, i) in products"
          v-if="i>0"
          :key="i"
          :cols="i === 0 ? 12 : 6"
          lg="6"
          xl="6"
        @click="openProductPage(product.route)"
        >
          <!--<img style="object-fit: contain" :src="product.image" alt="image"/>-->
          <div :class="[i==1?'ml-1':'','mb-1 black d-flex align-center']">
            <v-img
              class="p-col"
              :gradient="
                showHover === i
                  ? 'to right top, rgba(54, 91, 0, 0.88), rgba(54, 91, 0, 0.88)'
                  : ' to top right, rgb(4 4 4 / 33%), rgb(4 4 4 / 33%)'
              "
              :src="product.photo"
              :width="i==0?'100vw':'22vw'"
              :height="i==0?'100vw':'22vw'"
              contain
              transition="fade"
              @click="
                product.route !== 'malat'
                  ? openProductPage(product.route)
                  : null
              "
            >
              <div class="title-box" style="align-items: flex-start !important;background:#7bad32!important">
                <h3 @click="openProductPage(product.route)" class="white--text" >
                  {{ product.title }}
                </h3>
                <p dir="rtl" class="white--text mt-4 mb-3">{{ product.seo_description }}</p>
              </div>
            </v-img>
          </div>
        </v-col>
      </v-row>
          <v-col
          class="overflow-hidden position-relative pa-0"
           v-if="i===0"
          v-for="(product, i) in products"
          :key="i"
          :cols="i === 0 ? 12 : 6"
          lg="12"
          xl="12"
         
        @click="openProductPage(product.route)"
        >
          <!--<img style="object-fit: contain" :src="product.image" alt="image"/>-->
          <div :class="[i==1?'ml-1':'','mb-1 black d-flex align-center']">
            <v-img
              class="p-col"
              :gradient="
                showHover === i
                  ? 'to right top, rgba(54, 91, 0, 0.88), rgba(54, 91, 0, 0.88)'
                  : ' to top right, rgb(4 4 4 / 33%), rgb(4 4 4 / 33%)'
              "
              :src="product.photo"
              :width="i==0?'24vw':'50vw'"
              :height="i==0?'24vw':'50vw'"
              contain
              transition="fade"
              @click="
                product.route !== 'malat'
                  ? openProductPage(product.route)
                  : null
              "
            >
              <div class="title-box" style="align-items: flex-start !important;background:#7bad32!important">
                <h3 @click="openProductPage(product.route)" class="white--text" >
                  {{ product.title }}
                </h3>
                <p dir="rtl" class="white--text mt-4 mb-3">{{ product.seo_description }}</p>
              </div>
            </v-img>
          </div>
        </v-col>
    </div>
    <div v-else>
      <v-row no-gutters class="products-wrap">
        <v-col
          class="overflow-hidden position-relative pa-0"
          v-for="(product, i) in products"
          :key="i"
          :cols="i === 0 ? 12 : 6"
          lg="4"
          xl="4"
        @click="openProductPage(product.route)"
        >
          <!--<img style="object-fit: contain" :src="product.image" alt="image"/>-->
          <div :class="[i==1?'ml-1':'','mb-1']">
            <v-img
              class="p-col"
              :gradient="
                showHover === i
                  ? 'to right top, rgba(54, 91, 0, 0.88), rgba(54, 91, 0, 0.88)'
                  : ' to top right, rgb(4 4 4 / 33%), rgb(4 4 4 / 33%)'
              "
              :src="product.photo"
              :width="i==0?'100vw':'50vw'"
              :height="i==0?'100vw':'50vw'"
              contain
              transition="fade"
              @click="
                product.route !== 'malat'
                  ? openProductPage(product.route)
                  : null
              "
            >
              <div class="title-box" style="align-items: flex-start !important;background:#7bad32!important">
                <h3 @click="openProductPage(product.route)" class="white--text" >
                  {{ product.title }}
                </h3>
                <p dir="rtl" class="white--text mt-4 mb-3">{{ product.seo_description }}</p>
              </div>
            </v-img>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "lightBlocksProducts",
  data() {
    return {
      selectedIndex: 0,
      top: 0,
      down: 3,
      showHover: null,
    };
  },
  computed: {
    ...mapState({
      products: (state) => state.lightBlocksManagement.BlockHomeNewBanner && state.lightBlocksManagement.BlockHomeNewBanner[11] ? state.lightBlocksManagement.BlockHomeNewBanner[11].sub_categories:[],
    }),
  },
  methods: {
    openProductPage(route) {
      switch (route) {
        case "ajor":
          this.$router.push("/sub/light-blocks/construction/product/" + route);
          break;
        case "malat":
          this.$router.push("/sub/light-blocks/construction/products");
          break;
        case "block":
          this.$router.push("/sub/light-blocks/construction/product/" + route);
          break;
      }
    },
  },
};
</script>
<style scoped>
.child-style {
  color: rgba(255, 255, 255, 0.7);
}
.sub-style {
  text-decoration: none;
}

.sub-style:hover > * {
  color: white;
}

.icon-style {
  margin-left: 12px;
  color: rgba(255, 255, 255, 0.7);
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.7);
}

.product-title {
  font-weight: bold;
}

.product-title:hover {
  color: #7bad32;
}

.product-box {
  cursor: pointer;
}

.product-box:hover .product-title {
  color: #7bad32;
}

@keyframes img-anim {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.selected-item {
  background-color: #7bad32;
  border: 2px solid #7bad32;
}

.product-effect {
  opacity: 1;
  transition: all 0.4s;
  animation: product ease-in 0.4s;
}

@keyframes product {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}



.over-text-bottom {
  padding: 16px 8px;
  position: absolute;
  bottom: 16px;
  left: 16px;
  right: 16px;
}

.over-text-top {

  padding: 16px 8px;
  position: absolute;
  top: 32px;
  left: 16px;
  right: 16px;
}

.over-text-center {
  padding: 16px 8px;
  position: absolute;
  top: 40%;
  left: 16px;
  right: 16px;
}

.over-text-center-left {
  padding: 16px 8px;
  position: absolute;
  top: 40%;
  left: 32px;

}

.position-relative {
  position: relative;
  -webkit-animation: fadein 6s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadein 6s; /* Firefox < 16 */
  -ms-animation: fadein 6s; /* Internet Explorer */
  -o-animation: fadein 6s; /* Opera < 12.1 */
  animation: fadein 6s;
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Firefox < 16 */
@-moz-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Internet Explorer */
@-ms-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Opera < 12.1 */
@-o-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

h6 {
  margin: 0px !important;
  padding: 0px !important;
}
</style>
